export default __webpack_public_path__ + "static/media/checkbox.11c8acc4.svg";